<template>
    <div>
        <Transition name="fade">
            <div @click="closeAction" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <CommonPopupFrame :isShowBackground="false" :changeHeight="'auto'" :isOpen="isOpen" :closeCompleteAction="closeAction" :changeBottom="30">
            <div style="padding: 0 24px;">
                <div class="common_popup_header"></div>
                <div style="margin-top: 30px;">
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <div style="font-weight: 900; font-size: 24px; line-height: 32px;">시크릿 입단  요청서 열람</div>
                        <div @click="showDescPopup" style="width: 20px; height: 20px; border-radius: 50%; border: 2px solid #808080; color: #808080; text-align: center; font-weight: 700; font-size: 14px;">?</div>
                    </div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px; color: #797979;">선수의 비공개 상세 입단 요청서를 열람합니다.</div>
                </div>
                <div style="">
                    <div style="text-align: center;">
                        <template v-if="false">
                            <div style="margin-top: 13px; margin-bottom: 6px;">
                                <img style="width: 122px;" :src="require('@/assets/img/10000.png')" alt="">
                            </div>
                            <div class="price_title">1회 입단 요청서 결제</div>
                            <div class="price">10,000<span>원</span></div>
                            <div style="margin-top: 30px;">
                                <div class="modal_desc">
                                    <div class="modal_desc_icon">!</div>
                                    <div class="modal_desc_text">더 저렴하게 열람할 수는 없나요?</div>
                                </div>
                                <div class="pro_scout_wrapper">
                                    <div class="pro_scout_title">
                                        <div class="pro_scout_title_text">PRO 스카우트</div>
                                        <div class="pro_scout_discount">7,000원 할인!</div>
                                    </div>
                                    <div class="pro_scout_desc">멤버십 결제 시 시크릿 입단 요청서 열람권 <span>건당 3,000원</span></div>
                                </div>
                                <div @click="sendRequest" class="request_btn">열람 요청하기</div>
                            </div>
                        </template>
                        <template v-else-if="false">
                            <div style="margin-top: 10px; margin-bottom: 16px;">
                                <img style="width: 118px;" src="@/assets/img/5000.png" alt="">
                            </div>
                            <div class="price_title">1회 입단 요청서 결제</div>
                            <div class="first_cost">10,000원</div>
                            <div class="price">5,000<span>원</span></div>
                            <div style="margin-top: 20px;">
                                <div class="modal_desc">
                                    <div class="modal_desc_icon">!</div>
                                    <div class="modal_desc_text">더 저렴하게 열람할 수는 없나요?</div>
                                </div>
                                <div class="pro_scout_wrapper">
                                    <div class="pro_scout_title">
                                        <div class="pro_scout_title_text">PRO 스카우트</div>
                                        <div class="pro_scout_discount">7,000원 할인!</div>
                                    </div>
                                    <div class="pro_scout_desc">멤버십 결제 시 시크릿 입단 요청서 열람권 <span>건당 3,000원</span></div>
                                </div>
                                <div @click="sendRequest" class="request_btn">열람 요청하기</div>
                            </div>
                        </template>
                        <template v-else-if="true">
                            <div>
                                <img style="width: 127px;" :src="require('@/assets/img/3000.png')" alt="">
                            </div>
                            <div class="price_title">1회 입단 요청서 결제</div>
                            <div class="first_cost">10,000원</div>
                            <div class="price">3,000<span>원</span></div>
                            <div @click="sendRequest" class="request_btn">열람 요청하기</div>
                        </template>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
        <CommonPopupFrame :isOpen="isShowDescPopup" :closeCompleteAction="closeDescPopup" :changeHeight="'auto'" :changeBottom="20">
            <div style="padding: 0 24px;">
                <div class="common_popup_header"></div>
                <div style="margin-top: 30px; font-weight: 900; font-size: 24px; line-height: 32px;">시크릿 입단 요청서란?</div>
                <div style="margin-top: 22px;">
                    <div>
                        <div class="modal_title_wrapper">
                            <img style="width: 24px;" :src="require('@/assets/img/secret_desc_icon1.png')" alt="">
                            <div class="modal_title_text">철저한 익명성 보장</div>
                        </div>
                        <div class="modal_desc_text">
                            현재 소속팀에 있거나 조용히 이적/진학을 준비 중인 선수들을 위해, 이름과 소속팀을 비공개로 처리하여 선입견 없이 평가하실 수 있습니다.
                        </div>
                    </div>
                    <div style="margin-top: 15px;">
                        <div class="modal_title_wrapper">
                            <img style="width: 20px;" :src="require('@/assets/img/secret_desc_icon2.png')" alt="">
                            <div class="modal_title_text">KFA 1종 엘리트 인증 완료</div>
                        </div>
                        <div class="modal_desc_text">
                            대한축구협회(JOINKFA) 1종 등록 이력이 있거나, 공식 1종 팀에서 뛴 경험을 인증한 엘리트 선수들만 올릴 수 있는 입단 요청서입니다.
                            허위 입단 요청서 걱정 없이 안심하세요.
                        </div>
                    </div>
                    <div style="margin-top: 15px;">
                        <div class="modal_title_wrapper">
                            <img style="width: 24px;" :src="require('@/assets/img/secret_desc_icon3.png')" alt="">
                            <div class="modal_title_text">보호자(부모님) 동의 완료</div>
                        </div>
                        <div class="modal_desc_text">
                            모든 미성년자 선수는 보호자의 본인 인증과 더불어 이적 및 테스트 진행에 대한 사전 동의를 100% 마친 준비된 선수들입니다.
                        </div>
                    </div>
                    <div style="margin-top: 15px;">
                        <div class="modal_title_wrapper">
                            <img style="width: 24px;" :src="require('@/assets/img/secret_desc_icon4.png')" alt="">
                            <div class="modal_title_text">선수가 수락 시에만 비용 발생</div>
                        </div>
                        <div class="modal_desc_text">
                            감독님이 열람을 요청하더라도 선수가 거절하면 결제가 진행되지 않으니 안심하고 부담 없이 요청하세요.
                        </div>
                    </div>
                </div>
                <div style="margin-top: 30px;">
                    <div @click="closeDescPopup" class="request_btn">확인</div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import { SCOUT_POPUP_TYPE } from '@/Constants'

export default {
    name: 'RatePlanModal',
    components: { CommonPopupFrame },
    props: {

    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    data() {
        return {
            isOpen: false,
            isShowDescPopup: false,
            SCOUT_POPUP_TYPE: SCOUT_POPUP_TYPE,
        }
    },
    methods: {
        closeAction() {
            this.isOpen = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        closeDescPopup() {
            this.isShowDescPopup = false;
        },
        showDescPopup() {
            this.isShowDescPopup = true;
            console.log('showDescPopup');
        },
        sendRequest() {
            this.$GlobalStore.addModal('MemberPopupList', { 
                type: SCOUT_POPUP_TYPE.SEND_REQUEST,
                isModalBackTransparent: true,
                transitionName: '',
                btnClickAction: () => {
                    this.$GlobalStore.closeModalAll()
                }
            })
        }
    }
}
</script>

<style scoped>
.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.price_title {
    font-weight: 700;
    line-height: 24px;
}

.price {
    font-weight: 900;
    font-size: 40px;
    line-height: 48px;
}

.price span {
    font-size: 32px;
    font-weight: 700;
}

.first_cost {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    margin-top: 10px;
    color: #808080;
    text-decoration: line-through;
}

.request_btn {
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #210F03;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    margin-top: 30px;
}

.modal_desc {
    display: flex;
    align-items: center;
    gap: 5px;
}

.modal_desc_icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #808080;
    text-align: center;
    font-size: 11px;
    font-weight: 700;
}

.modal_desc_text {
    font-size: 12px;
    line-height: 24px;
    font-weight: 700;
    color: #808080;
}

.pro_scout_wrapper {
    padding: 12px;
    background-color: #fff7ef;
    border-radius: 12px;
    border: 1px solid #ffecd5;
    margin-top: 5px;
}

.pro_scout_title {
    display: flex;
    align-items: center;
    gap: 5px;
}

.pro_scout_title_text {
    padding: 0 5px;
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #fff;
    background-color: var(--color-main);
    border-radius: 4px;
}

.pro_scout_discount {
    font-weight: 900;
    font-size: 12px;
    line-height: 24px;
    color: var(--color-main);
}

.pro_scout_desc {
    margin-top: 3px;
    color: #b36300;
    font-size: 12px;
    font-weight: 900;
    line-height: 24px;
    text-align: left;
}

.pro_scout_desc span {
    margin-left: 5px;
    color: var(--color-main);
    font-size: 14px;
}

.modal_title_wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
}

.modal_title_text {
    font-weight: 700;
    line-height: 24px;
}

.modal_desc_text {
    margin-top: 5px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #808080;
}
</style>